import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { ValidateCSVAndUnmapRespondentsFromSpocsRPC } from "./validateCsvAndUnmapRespondentsFromSpocsRPC";

export class ValidateCSVAndUnmapRespondentsFromSpocsRPCClientImpl extends ValidateCSVAndUnmapRespondentsFromSpocsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: ValidateCSVAndUnmapRespondentsFromSpocsRPC.Request): Promise<LeoRPCResult<ValidateCSVAndUnmapRespondentsFromSpocsRPC.Response, ValidateCSVAndUnmapRespondentsFromSpocsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "spoc-management/ValidateCSVAndUnmapRespondentsFromSpocs",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      ValidateCSVAndUnmapRespondentsFromSpocsRPC.ResponseDTO,
      ValidateCSVAndUnmapRespondentsFromSpocsRPC.Errors.ErrorsDTO,
      ValidateCSVAndUnmapRespondentsFromSpocsRPC.Response,
      ValidateCSVAndUnmapRespondentsFromSpocsRPC.Errors.Errors
    >(
      response,
      "spoc-management/ValidateCSVAndUnmapRespondentsFromSpocs",
      ValidateCSVAndUnmapRespondentsFromSpocsRPC.Response.fromDTO,
      ValidateCSVAndUnmapRespondentsFromSpocsRPC.Errors.fromDTO
    );
  }
}
